import React from 'react';

import Settings from './index';

export default class ApexSettings extends React.Component {
  render() {
    return <Settings {...this.props} />;
  }
}
